<template>
  <v-card>
    <div>
      <div style="display: flex; justify-content: space-between">
        <div style="align-self: center; font-size: 23px; font-weight: 600" class="pl-3">
          {{ edittype == 'create' ? 'Create Category' : 'Edit Category' }}
        </div>
        <div>
          <v-btn @click="$emit('close')" style="float: right" icon><v-icon>close</v-icon></v-btn>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <div class="pa-2">
      <div class="form-control" :class="{ 'has-error': errors.has('Category image') }">
        <uploadfile
          :data-vv-as="$t('Category image')"
          name="Category image"
          v-validate="'required'"
          v-model="input.photourl"
        ></uploadfile>
        <p class="text-error" v-if="errors.has('Category image')">
          {{ errors.first('Category image') }}
        </p>
      </div>
      <div class="pa-3">
        <div>Category name</div>
        <div class="form-control" :class="{ 'has-error': errors.has('name') }">
          <input
            :data-vv-as="$t('Category')"
            name="name"
            v-validate="'required'"
            type="text"
            v-model="input.name"
          />
          <p class="text-error" v-if="errors.has('name')">
            {{ errors.first('name') }}
          </p>
        </div>
      </div>
      <div class="text-xs-center">
        <v-btn @click="$emit('close')" color="grey" outline> {{ $t('cancel') }}</v-btn>
        <v-btn :loading="loading" @click="saveData" color="primary" depressed>
          {{ $t('Save') }}</v-btn
        >
      </div>
    </div>
  </v-card>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  components: {
    uploadfile
  },
  props: ['editdata', 'edittype'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      input: {
        name: '',
        photourl: ''
      },
      loading: false
    }
  },
  created() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async saveData() {
      if (await this.$validator.validate()) {
        var data = {
          pageid: this.selectedBot.pageid,
          name: this.input.name,
          photourl: this.input.photourl
        }
        this.loading = true
        if (this.edittype == 'create') {
          api.postmjdservicescategory(data, async (err, response) => {
            if (response.responsecode == 200) {
              await this.$swal.fire({
                type: 'success',
                text: 'สำเร็จ'
              })
            }
            this.$emit('oncreate', response.data[0])
          })
        } else {
          api.putmjdservicescategory(
            { ...data, category_id: this.editdata.id },
            async (err, response) => {
              if (response.responsecode == 200) {
                await this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
              this.$emit('onedit', { ...data, id: this.editdata.id })
            }
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/Products.vue